import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import { OffersStore } from '../../mobx-store/stores/offersStore';
import { stores } from 'mobx-store';

interface IProps extends WithSnackbarProps {
  offersStore: OffersStore;
  history: any;
}

@inject('offersStore')
@observer
class OffersScreen extends Component<IProps> {
  title: string = translate('offersListPageTitle');

  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  tableData: any[] = [];

  constructor(props: IProps) {
    super(props);
    this.addButton = this.getAddOffersButton();
    this.tableHeader = this.getOffersTableHeader();
    this.tableCellTypes = this.getOfferTableCellTypes();
  }

  async handleSort(direction: 'up' | 'down', row: any) {
    try {
      const offers = this.props.offersStore.offersList;

    // Create a clean working copy: [{ offerId, sortOrder }]
    const offersSort = offers.map(o => ({
      offerId: o.offerId,
      sortOrder: o.sortOrder
    }));

    // Find the current offer in this new array
    const current = offersSort.find(o => o.offerId === row.offerId);
      if (!current) {
        console.log('return 1')
        return;
      };

    const oldOrder = current.sortOrder;
    const newOrder = direction === 'up' ? oldOrder + 1 : oldOrder - 1;

    // Find the offer currently at the newOrder position
    const swapWith = offersSort.find(o => o.sortOrder === newOrder);
      if (!swapWith) {
        console.log('return 2')
        return;
      };
    // Swap sortOrder values
    current.sortOrder = newOrder;
    swapWith.sortOrder = oldOrder;
    this.props.offersStore.loading = true;
    // Save the updated array back into the store (if needed)
    await this.props.offersStore.updateOffersSort(offersSort);
    this.props.offersStore.getOffers(stores.countryStore.managedCountries);

    console.log("Updated sort array:", offersSort);
    } catch (error) {
      console.log(error)
    }
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/offers/${this.props.offersStore.offersList[index].offerId}/edit`,
    );
  };

  handelAdd = (): void => {
    this.props.history.push('/offers/new');
  };

  getAddOffersButton = () => ({
    title: translate('addButton'),
    onAdd: this.handelAdd,
  });

  getOffersTableHeader = () => [
    {
      title: translate('title'),
    },
    {
      title: translate('Status'),
    },
    {
      title: translate('HotDeal'),
    },
    {
      title: translate('editButton'),
    },
  ];

  getOffersTableData = () => this.props.offersStore.offersList
    .map((offer) => ({
      ...offer, edit: translate('editButton'),
    }));

  getOfferTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',  
      activeLabel: translate('FormActiveLabel'),
      inactiveLabel: translate('FormNotActiveLabel'),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'ToggleButton',
      key: 'isHotDeal',  
      activeLabel: translate('HotDeal'),
      inactiveLabel: translate('NotHotDeal'),
      onChange: this.handleIsHotDealToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];
  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.offersStore.updateOffer({isActive: value}, this.props.offersStore.offersList[index].offerId)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
        this.props.offersStore.offersList[index].isActive = value;
      })
      .catch((error: any) => {
        console.log(error)
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };
  handleIsHotDealToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.offersStore.updateOffer({isHotDeal: value}, this.props.offersStore.offersList[index].offerId)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
        this.props.offersStore.offersList[index].isHotDeal = value;
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  render() {
    this.tableData = this.getOffersTableData();


    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('offersListNoMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loading={this.props.offersStore.loading}
          sort={(fn, row) => this.handleSort(fn, row)}
        />
      </div>
    );
  }

  async componentDidMount() {
    await stores.countryStore.getUserManagedCountries();
    this.props.offersStore.getOffers(stores.countryStore.managedCountries);
  }
}

export default OffersScreen;
